import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { LearningPathSetupFlow } from "@/features/admin/learning-path-setup/LearningPathSetupFlow";

export const Route = createFileRoute("/admin/learning-paths/new")({
  component: NewLearningPathPage,
});

function NewLearningPathPage() {
  // A permission or a role lets someone in, so the role has to be one that may create paths.
  return (
    <ProtectedRoute requiredPermissions={["Courses.Manage"]} requiredRoles={["SuperAdmin"]}>
      <AdminPageLayout>
        <LearningPathSetupFlow />
      </AdminPageLayout>
    </ProtectedRoute>
  );
}
